/* unplugin-vue-components disabled */import script from "./privacy.vue?vue&type=script&lang=ts&setup=true"
export * from "./privacy.vue?vue&type=script&lang=ts&setup=true"

import "./privacy.vue?vue&type=style&index=0&id=c5cd1a12&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5cd1a12"]])

export default __exports__